module.exports = __webpack_public_path__ + "img/02.4b20c370.jpg";